import { useApprovalReportUpdater } from "./useApprovalReportUpdater";

export default useApprovalReportUpdater;
